import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { InputComponent, MakeProvider } from '../input-component';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss'],
  providers: [MakeProvider(PasswordInputComponent)]
})
export class PasswordInputComponent extends InputComponent implements OnInit {

  @Input() autoComplete = 'on';
  @Input() show: boolean = false;
  get type() {return this.show ? 'text' : 'password'; }

  constructor(private platform: Platform) {
    super();
  }

//  get isMobile() { return this.platform.is('mobileweb'); }

  ngOnInit() { }

  override checkValidity() {
    super.checkValidity();
    // if (this.isValid) {
    //   this.checkingValidity.emit(this);
    // }
  }


  // toggleShow() {
  //   this.type = (this.type === 'password') ? 'text' : 'password';
  // }

}
